import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Overline } from "@/components/Reveal";
import { PageHero, Section, Button } from "@/components/UI";

const STANDARDS = [
  { n: "01", t: "Scope of Practice", d: "Defines restorative paramedical micropigmentation and its boundaries — the conditions, applications, and referral relationships that fall within a certified practitioner's remit, and those that do not." },
  { n: "02", t: "Standards of Practice", d: "The clinical benchmarks every certified practitioner must meet: assessment, treatment planning, documentation, aftercare, and outcome review." },
  { n: "03", t: "Code of Ethics", d: "Duties to the patient, the public, and the profession — including honesty in advertising, boundaries, and conflict-of-interest disclosure." },
  { n: "04", t: "Infection Prevention & Control", d: "Requirements for sterilization, single-use instrumentation, cross-contamination prevention, and a safe practice environment consistent with public-health guidance." },
  { n: "05", t: "Informed Consent", d: "A staged consent process ensuring patients understand the procedure, risks, expected outcomes, and their right to pause or withdraw at any time." },
  { n: "06", t: "Trauma-Informed Care", d: "Recognizing that restorative patients often carry medical trauma, and embedding emotional safety, pacing, and dignity into every stage of care." },
  { n: "07", t: "Continuing Competency", d: "Ongoing education, case review, and demonstrated competency required to maintain certification." },
];

export default function Standards() {
  return (
    <>
      <PageHero overline="National Standards" testId="standards-hero"
        title="The standards that define the discipline"
        subtitle="A single, national framework for restorative paramedical micropigmentation — establishing scope, ethics, safety, and care expectations for every certified practitioner in Canada." />

      <Section className="py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <Overline>Draft for consultation</Overline>
                <h2 className="font-serif text-3xl text-ccpm-charcoal mt-4 leading-tight">Seven pillars, one standard.</h2>
                <p className="mt-5 text-ccpm-taupe font-light leading-relaxed">These standards are in active development and open for public consultation. They form the basis of CCPM certification and the public's assurance of safe, competent care.</p>
                <Button to="/resources" variant="outline" className="mt-8" data-testid="standards-download">Access the resource library</Button>
              </Reveal>
            </div>
          </div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible defaultValue="item-0" className="border-t border-ccpm-border" data-testid="standards-accordion">
              {STANDARDS.map((s, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-ccpm-border">
                  <AccordionTrigger className="py-7 hover:no-underline group" data-testid={`standard-${i}`}>
                    <div className="flex items-baseline gap-5 text-left">
                      <span className="font-serif text-lg text-ccpm-olive-soft">{s.n}</span>
                      <span className="font-serif text-2xl lg:text-3xl text-ccpm-charcoal group-hover:text-ccpm-olive transition-colors">{s.t}</span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="pb-8 pl-10 text-ccpm-taupe font-light leading-relaxed text-base">{s.d}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </Section>
    </>
  );
}
